// C:\Users\ADMIN\Desktop\ERP\myerp\my-frontend\src\pages\etc\Vendors.jsx
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import VendorRibbon from "../../components/etc/VendorRibbon";
import VendorRegister from "../../components/etc/VendorRegister";
import VendorBalance from "../../components/etc/VendorBalance";
import styles from "./Vendors.module.css";

export default function Vendors() {
  const location = useLocation();
  // ✅ 인건비 빠른 입력 흐름의 "거래처(급여계좌)가 등록되어 있습니까? → 아니오"
  // 경로로 들어오면 신규 등록 시 "급여계좌" 체크박스가 기본 체크되게 한다.
  const defaultSalaryAccount = !!location.state?.defaultSalaryAccount;

  const [activeTab, setActiveTab] = useState("등록");
  const [searchQuery, setSearchQuery] = useState("");
  const [activeSearchQuery, setActiveSearchQuery] = useState("");

  const handleSearch = () => {
    setActiveSearchQuery(searchQuery);
    console.log("검색:", searchQuery);
  };

  const handleReset = () => {
    setSearchQuery("");
    setActiveSearchQuery("");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className={styles.container}>
      <h2>거래처 관리</h2>
      <VendorRibbon activeTab={activeTab} onChange={setActiveTab} />

      {/* ✅ 검색 영역 */}
      <div
        style={{
          marginBottom: "15px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          width: "fit-content",
        }}
      >
        <input
          type="text"
          placeholder="거래처명 또는 사업자번호로 검색"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyPress={handleKeyPress}
          style={{
            padding: "8px 12px",
            width: "400px",
            height: "36px",
            fontSize: "14px",
            border: "1px solid #bbb",
            borderRadius: "6px",
            backgroundColor: "white",
            color: "#333",
            boxSizing: "border-box",
          }}
        />

        <button
          type="button"
          onClick={handleSearch}
          style={{
            padding: "8px 16px",
            width: "auto", // ✅ 70px → auto로 변경
            minWidth: "70px", // ✅ 최소 너비 설정
            height: "36px",
            fontSize: "14px",
            cursor: "pointer",
            border: "1px solid #bbb",
            borderRadius: "6px",
            backgroundColor: "white",
            color: "#333",
            boxSizing: "border-box",
            flexShrink: 0,
            whiteSpace: "nowrap", // ✅ 줄바꿈 방지
            marginTop: "-6px", // ✅ 버튼만 5px 위로 올림

          }}
        >
          검색
        </button>

        <button
          type="button"
          onClick={handleReset}
          style={{
            padding: "8px 16px",
            width: "auto", // ✅ 70px → auto로 변경
            minWidth: "70px", // ✅ 최소 너비 설정
            height: "36px",
            fontSize: "14px",
            cursor: "pointer",
            border: "1px solid #bbb",
            borderRadius: "6px",
            backgroundColor: "white",
            color: "#333",
            boxSizing: "border-box",
            flexShrink: 0,
            whiteSpace: "nowrap", // ✅ 줄바꿈 방지
            marginTop: "-6px", // ✅ 버튼만 5px 위로 올림

          }}
        >
          초기화
        </button>
      </div>

      {activeTab === "등록" && (
        <VendorRegister searchTerm={activeSearchQuery} defaultSalaryAccount={defaultSalaryAccount} />
      )}
      {activeTab === "잔액" && <VendorBalance searchTerm={activeSearchQuery} />}
      {activeTab !== "등록" && activeTab !== "잔액" && (
        <div style={{ padding: "40px", textAlign: "center", color: "#777" }}>
          {activeTab} 화면 준비 중입니다.
        </div>
      )}
    </div>
  );
}